import { Component, OnInit, Input, ViewChildren } from '@angular/core';
import { TooltipComponent } from "../../../../common/tooltip/tooltip.component";

@Component({
    selector: 'calendar-detail',
    templateUrl: '../../templates/partials/calendar-detail.html'
})

export class CalendarDetailComponent implements OnInit {
    constructor() { }
    @Input() availability;
    public popUpHtml;
    public previosTooltip = null;
    @ViewChildren("pop") tooltips;


    public setItemClass(hour){
        //console.log(hour);
        var n_hours = (hour["service"]["n_hours"] * 2) + 1;
         if(hour.available == "notAvailable"){
            return ""
        }
        else if(hour.available == "available"){
            return "c-select-hours-cleaner__item--active";
        }
        else if(hour.available == "busy"){
            return "c-select-hours-cleaner__item--selection-" + n_hours;
        }
       
    }

    public show(element,hour){
        if(hour["available"] != "available"){
            if(this.previosTooltip != null){
                this.previosTooltip.hide();
            }
            element.show();
            this.previosTooltip = element;
        }else{
            if(this.previosTooltip != null){
                this.previosTooltip.hide();
            }
        }
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/availability/components/dummy/calendar-detail.component.ts